export const DEFAULT_REGEX = "\\d+,\\d{2}";

export interface IExtractResult {
  value: string;
  matched: boolean;
}

export function extractFromColumn(
  rows: string[][],
  columnIndex: number,
  regex: string
): IExtractResult[] {
  let re: RegExp;
  try {
    // Support patterns provided like `/pattern/flags` as well as plain patterns
    let pattern = regex;
    let flags = "";
    if (pattern.startsWith("/")) {
      const lastSlash = pattern.lastIndexOf("/");
      if (lastSlash > 0) {
        flags = pattern.slice(lastSlash + 1);
        pattern = pattern.slice(1, lastSlash);
      }
    }
    re = new RegExp(pattern, flags);
  } catch {
    return [];
  }

  return rows.map((row) => {
    let cell = String(row[columnIndex] ?? "");
    // Normalize whitespace and non-breaking spaces, remove CR and surrounding quotes, then trim
    cell = cell.replace(/\u00A0/g, " ").replace(/\r/g, "").replace(/^['"]|['"]$/g, "").replace(/\s+/g, " ").trim();
    if (re.global) re.lastIndex = 0;
    const match = re.exec(cell);
    if (match) {
      return { value: match[1] ?? match[0], matched: true };
    }
    return { value: "", matched: false };
  });
}
